<template>
  <div>
    <v-app-bar
      @scroll="$route.path === '/' ? handleScroll : ''"
      class="header-mobile"
      :class="[$route.path === '/' ? 'header-home' : 'header-view']"
      fixed
    >
      <router-link to="/">
        <img
          v-if="informations.img"
          :src="files + informations.img"
          :alt="informations.name"
          height="46px"
          class="d-block header-home-logotipo"
        />
      </router-link>

      <v-spacer />

      <v-app-bar-nav-icon
        class="toggle-menu"
        color="white"
        @click="showNavigationDrawer"
      />
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  methods: {
    showNavigationDrawer() {
      window.showNavigationDrawer();
    },
    handleScroll() {
      if (document.documentElement.scrollTop > 50)
        document
          .getElementsByTagName("body")[0]
          .classList.add("v-app-bar--is-active");
      else
        document
          .getElementsByTagName("body")[0]
          .classList.remove("v-app-bar--is-active");
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.header-home::v-deep {
  background: rgb(0, 0, 0);
  background: -moz-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  background-color: transparent !important;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#000000",GradientType=1);
}

.header-view {
  background-color: var(--v-primary-base) !important;
}

.header-home,
.header-view {
  box-shadow: none !important;

  .header-home-logotipo {
    filter: brightness(0) invert(1);
    transition: height 0.1s linear;
  }
}
</style>

<style lang="scss">
.v-app-bar--is-active {
  .header-mobile {
    background: #ffffff !important;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
    filter: none;

    .header-home-logotipo {
      filter: none;
    }

    .toggle-menu {
      color: var(--v-primary-base) !important;
    }
  }
}
</style>
